<main class="bg-black text-white min-h-screen overflow-x-hidden">

  <!-- Hero -->
  <section class="relative min-h-[65vh] flex items-center pt-24 pb-14 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 right-0 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="absolute inset-0 opacity-[0.025]" style="background-image: linear-gradient(rgba(0,170,230,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(0,170,230,0.5) 1px, transparent 1px); background-size: 60px 60px;"></div>

    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="max-w-3xl">
        <a routerLink="/products/connectiq" class="back-nav" data-aos="fade-down">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient"><polyline points="15 18 9 12 15 6"></polyline></svg>
          Back
        </a>
        <h1 class="hero-col font-black mb-5" data-aos="fade-up" data-aos-delay="100">
         <span class="sm:whitespace-nowrap"> Varroc Miles <span class="text-varroc-accent">Loyalty &amp; Rewards</span></span> Program
        </h1>
        <p class="text-varroc-text-gray text-lg leading-relaxed mb-8 max-w-2xl" data-aos="fade-up" data-aos-delay="200">
          Varroc Miles is a behaviour-driven loyalty program that rewards drivers for safe and responsible driving. Every safe trip earns miles that can be tracked in real time and redeemed through the V-Store for exclusive partner offers.
        </p>
        <div class="flex flex-wrap gap-4" data-aos="fade-up" data-aos-delay="300">
          <a routerLink="/contact-us" class="bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all varroc_miles_loyalty_rewards_program_start_rewarding_drivers_button">
            Start Rewarding Drivers
          </a>
          <a routerLink="/products/connectiq/vstore" class="border border-varroc-accent/40 font-semibold px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all varroc_miles_loyalty_rewards_program_explore_v_store_button">
            Explore V-Store
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- Sticky Nav -->
  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id" class="cursor-pointer flex-shrink-0">
          <i class='bx text-base' [class]="s.icon"></i> {{ s.label }}
        </a>
      </div>
    </div>
  </nav>

  <!-- Content -->
  <div class="max-w-7xl mx-auto px-6 py-20 space-y-28">

    <!-- Overview -->
    <section id="overview" class="section-anchor">
      <div class="grid md:grid-cols-2 gap-12 items-start">
        <div data-aos="fade-right">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">What Is Varroc Miles</span>
          <h2 class="text-4xl font-black mt-3 mb-5">Rewarding Safe Driving, Automatically</h2>
          <p class="text-varroc-text-gray leading-relaxed mb-5">Varroc Miles bridges the gap between safe driving behaviour and tangible rewards. Powered by VC-SCORE, every trip is evaluated and safe drivers automatically accumulate miles in their account — no manual tracking or separate entry required.</p>
          <p class="text-varroc-text-gray leading-relaxed">OEMs and service providers can configure earning rates, attach campaigns to specific behaviours, and set expiry policies — creating a fully branded loyalty experience inside the connected vehicle ecosystem.</p>
        </div>
        <div class="grid grid-cols-2 gap-4" data-aos="fade-left">
          <div class="feature-card text-center py-6">
            <i class='bx bx-check-shield icon-gradient text-4xl mb-3'></i>
            <div class="text-white font-bold text-sm">Behaviour-Based</div>
            <div class="text-varroc-text-gray text-xs mt-1">Auto-credited from drive data</div>
          </div>
          <div class="feature-card text-center py-6">
            <i class='bx bx-pulse icon-gradient text-4xl mb-3'></i>
            <div class="text-white font-bold text-sm">Real-Time</div>
            <div class="text-varroc-text-gray text-xs mt-1">Live miles in app</div>
          </div>
          <div class="feature-card text-center py-6">
            <i class='bx bx-gift icon-gradient text-4xl mb-3'></i>
            <div class="text-white font-bold text-sm">Redeemable</div>
            <div class="text-varroc-text-gray text-xs mt-1">Via V-Store marketplace</div>
          </div>
          <div class="feature-card text-center py-6">
            <i class='bx bx-trending-up icon-gradient text-4xl mb-3'></i>
            <div class="text-white font-bold text-sm">Scalable</div>
            <div class="text-varroc-text-gray text-xs mt-1">Millions of drivers</div>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- Features -->
    <section id="features" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">What You Get</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Key Features</h2>
        <p class="text-varroc-text-gray max-w-2xl mr-auto">Everything needed to run a complete driver rewards program — from earning logic to redemption journeys.</p>
      </div>
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div *ngFor="let h of highlights; let i = index" class="feature-card flex items-start gap-4" data-aos="fade-up" [attr.data-aos-delay]="i * 60">
          <div class="w-10 h-10 bg-varroc-accent/15 rounded-xl flex items-center justify-center flex-shrink-0">
            <i class='bx icon-gradient text-xl' [class]="h.icon"></i>
          </div>
          <div>
            <h3 class="text-white font-semibold text-sm mb-1">{{ h.label }}</h3>
            <p class="text-varroc-text-gray text-xs leading-relaxed">{{ h.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- Journey -->
    <section id="journey" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">How It Works</span>
        <h2 class="text-4xl font-black mt-2 mb-4">The Rewards Journey</h2>
        <p class="text-varroc-text-gray max-w-2xl mr-auto">A seamless four-step loop from driving safely to claiming rewards — with no manual intervention required.</p>
      </div>
      <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div *ngFor="let step of journey; let i = index" class="feature-card text-center" data-aos="fade-up" [attr.data-aos-delay]="i * 80">
          <div class="text-varroc-accent font-black text-3xl mb-3 opacity-40">{{ step.step }}</div>
          <h3 class="text-white font-bold text-base mb-2">{{ step.label }}</h3>
          <p class="text-varroc-text-gray text-sm">{{ step.desc }}</p>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- Campaigns -->
    <section id="campaigns" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Engagement Tools</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Campaign Types</h2>
        <p class="text-varroc-text-gray max-w-2xl mr-auto">Create targeted campaigns that boost driver engagement and incentivize specific behaviours aligned with your product goals.</p>
      </div>
      <div class="grid md:grid-cols-2 gap-6">
        <div *ngFor="let camp of campaignTypes; let i = index" class="feature-card" data-aos="fade-up" [attr.data-aos-delay]="i * 70">
          <h3 class="text-white font-bold text-lg mb-2">{{ camp.title }}</h3>
          <p class="text-varroc-text-gray text-sm leading-relaxed">{{ camp.desc }}</p>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="workflow" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Workflow</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Miles and Score Workflow</h2>
        <p class="text-varroc-text-gray max-w-2xl mr-auto">This vertical workflow diagram shows how driving behaviour, VC-SCORE evaluation, rewards logic, campaign triggers, and redemption journeys connect across the Varroc Miles ecosystem.</p>
      </div>
      <div class="flex justify-center" data-aos="fade-up">
        <img [src]="workflowImage" alt="Varroc Miles and score workflow diagram" class="w-full max-w-8xl h-auto rounded-xl block">
      </div>
    </section>

    <!-- CTA -->
    <!-- <section class="text-center py-16 bg-gradient-to-r from-varroc-accent/10 via-varroc-dark to-varroc-accent/10 border border-varroc-accent/20 rounded-3xl" data-aos="fade-up">
      <h2 class="text-4xl font-black mb-4">Launch Your Driver Rewards Program</h2>
      <p class="text-varroc-text-gray text-lg mb-8 max-w-2xl mx-auto">Varroc Miles integrates natively with VC-SCORE and V-Store to deliver a complete, OEM-branded loyalty experience from day one.</p>
      <div class="flex flex-wrap gap-4 justify-center">
        <a routerLink="/contact-us" class="bg-varroc-accent text-white font-bold px-10 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all text-lg">Talk to Team</a>
        <a routerLink="/products/connectiq" class="border border-varroc-accent/40 font-semibold px-10 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all text-lg">Back to ConnectIQ</a>
      </div>
    </section> -->

  </div>
</main>
